module.exports = __webpack_public_path__ + "static/media/SakenomyLogo_landscape.a9355951.jpg";